const Partners = Object.freeze({
  ENAOS: 'enaos',
  FRAGMENT: 'fragment',
  FUNEBRA: 'funebra',
  LEGACIO: 'legacio',
  FUNE_UP: 'fune_up',
  YOUSIGN: 'yousign',
  CREMAGEST: 'cremagest',
  SORENIR: 'sorenir',
  CYBILLE: 'cybille',
  KITTY_FOR_RELATIVES: 'kitty_for_relatives',
  CHIFT: 'chift',
  SQUARE_UP: 'square_up',
  I_ASSURE: 'i_assure',
  MESANGE_PREVOYANCE: 'mesange_prevoyance',
  STONE_MANAGER: 'stone_manager',
  PEPPOL: 'peppol',
  ELYS: 'elys',
  GUEST_SUITE: 'guest_suite',
  BILL_IT: 'bill_it'
})

export default Partners
